import React from 'react'
import { connect } from 'react-redux'

import LineChart from '~/components/charts/line-chart'
import Panel from '~/components/Panel'

const RevenueChart = ({ loading, data = {} }) => (
  <Panel title="Receita" isLoading={loading}>
    <LineChart data={data.incomeHomeDash} loading={loading} />
  </Panel>
)

export default connect(store => ({
  theme: store.theme.currentTheme
}))(RevenueChart)
